// src/store//thunks/adminForm/updateAdminThunk.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import type { AdminEntity, AdminUpsertDTO, AdminId } from '@/types/administrators.types';
import { normalizeEmail } from '@/utils/strings/strings';

import { withLoader, withErrorHandling } from '../thunkWrappers';
import { fetchAdminInfoThunk } from '../auth/fetchAdminInfoThunk';

export interface UpdateAdminArgs {
  id: AdminId;
  data: AdminUpsertDTO;
}

export const updateAdminThunk = createAdminAsyncThunk<AdminEntity, UpdateAdminArgs>(
  'administrators/update',
  withLoader(
    withErrorHandling(
      async({ id, data }, { extra: { administratorsService }, dispatch, getState }) => {
        const adminUpdate = await administratorsService.update(id, {
          ...data,
          email: normalizeEmail(data.email),
        });
        const state = getState();
        if (id === state.auth.userId) {
          void dispatch(fetchAdminInfoThunk({ id }));
        }
        return adminUpdate;
      }
    )
  )
);
